import React from "react";
import { Box } from "arkh";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { HeaderButton } from "../../components";
import { ErrorFallbackWithLogout } from "../../TopLevelNavigators/UserLoggedIn/ErrorFallbackWithLogout";
import { AuthenticatedUsersHorizontalList } from "../../OS/AuthenticatedUsers/AuthenticatedUsersHorizontalList";
import { FallbackProps } from "react-error-boundary";
import { useNavigation } from "@react-navigation/native";
import { Props } from "./TeamNavigator";

export function TeamNavigatorErrorFallback(props: FallbackProps) {
  const navigation = useNavigation<Props["navigation"]>();
  const canGoBack = navigation.canGoBack();
  const insets = useSafeAreaInsets();
  return (
    <>
      <Box insets={insets}>
        {canGoBack ? (
          <Box spaceHorizontal="medium">
            <HeaderButton type="BACK" onPress={() => navigation.goBack()} />
          </Box>
        ) : (
          <AuthenticatedUsersHorizontalList backgroundColor="background" />
        )}
      </Box>
      <ErrorFallbackWithLogout resetErrorBoundary={props.resetErrorBoundary} />
    </>
  );
}
